import React from 'react';
import { history } from 'umi';

import styles from './styles.scss';

import CourseList from './CourseList.jsx';

export default (props) => {

  const { dataList } = props;

  return (
    <>
      {
        dataList.map(item => (
          <div key={item.id}>
            <div className={styles.categoryHeader}>
              <div className={styles.line}/>{item.courseCategory.name}<div className={styles.line}/>

              <a onClick={() => {
                history.push({pathname:'/home/courseList',state:{title:item.courseCategory.name ,categoryId:item.categoryId}})
              }}>更多></a>
            </div>

            <CourseList dataList={item.courseList} courseType={item.courseType}/>

          </div>
        ))
      }
    </>
  )

}


